import { useContext } from 'react';

import { PermissionsContext } from '@/shared/features/permissions/context/permissions-context';
import { TUsePermissionCheck } from '@/shared/features/permissions/context/permissions-context.types';
import {
  can,
  canAny,
} from '@/shared/features/permissions/utils/permission-matchers';

export const usePermissionCheck = (): TUsePermissionCheck => {
  const { model, isLoading } = useContext(PermissionsContext);

  return {
    can: (actions, ids) => (model ? can(model, actions, ids) : true),
    canAny: (actions, ids) => (model ? canAny(model, actions, ids) : true),
    isLoading,
  };
};
